export default __webpack_public_path__ + "3147d9b9d6b359bdf2f7e947d94a886d.svg";